import { render, staticRenderFns } from "./CoastsBottomProfilePlot.vue?vue&type=template&id=444bbcae&scoped=true"
import script from "./CoastsBottomProfilePlot.vue?vue&type=script&lang=js"
export * from "./CoastsBottomProfilePlot.vue?vue&type=script&lang=js"
import style0 from "./CoastsBottomProfilePlot.vue?vue&type=style&index=0&id=444bbcae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444bbcae",
  null
  
)

export default component.exports